var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#efefef",
    width: "800px",
    height: "800px",
    viewBox: "-7 0 32 28",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#efefef",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "four"), /*#__PURE__*/React.createElement("path", {
    d: "M13.719 1.375v15.438h2.781v2.25h-2.781v6.531h-2.219v-6.531h-10.219zM5.594 16.813h5.906v-8.344z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFour);
export default __webpack_public_path__ + "static/media/four.bb8faeb40e666d565140402f1cb72edd.svg";
export { ForwardRef as ReactComponent };